import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChecksDetailService } from './checks-detail.service';

@Component({
  selector: 'gf-checks-detail-list',
  template: require('./checks-detail-list.component.html')
})
export class ChecksDetailListComponent implements OnChanges {
  @Input() result: any;
  @Input() unixName: string;

  resultXformed: any = false;

  constructor(private checksDetailService: ChecksDetailService) {}

  ngOnInit() {
    if (this.result) {
      this.resultXformed = this.checksDetailService.transformDetails(this.result, this.unixName);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['result'] && this.result) {
      this.resultXformed = this.checksDetailService.transformDetails(this.result, this.unixName);
    } else {
      this.resultXformed = false;
    }
  }
}
